const api = process.env.API_ROOT || '"https://dev.slashdr.com"';
const jQuery401Callback = (xhr, error) => {
  if (xhr.status === 401) {
    // alert("Invalid credentials");
    localStorage.clear();
    window.location.href = "/";
  }
  console.log("jQuery401Callback");
};
const REPORTS_API_ROOT =
  process.env.REPORTS_API_ROOT || "https://reports.slashdr.com";

console.log(REPORTS_API_ROOT);
const MAPS_APIKEY = "AIzaSyAI0YgUyNFp6ULvucb8qcmqZLsF2d1rEdA";
export { api, REPORTS_API_ROOT, jQuery401Callback };



// WEBPACK FOOTER //
// ./src/api.js